import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation, Trans } from 'react-i18next';

import { Flex, Image, Text, ButtonFilled, ButtonText } from 'Components/Base';
import Loading from 'Components/Loading';

const ClearErrorContent = ({ onResendQuestion, onBackToClassroom, loading }) => {
  const { t } = useTranslation('classroom');
  return (
    <Flex width={1} flexDirection={'column'} alignItems={'center'} height="100%">
      <Image maxWidth={140} src="/assets/images/classroom/clearErrorModal.svg" />
      <Flex width={1} flexDirection={'column'} alignItems={'center'}>
        <Text textStyle={'heading2'} mt={6} textAlign={'center'}>
          {t('CLEAR_BY_LEARNED.ERROR_MODAL.TITLE')}
        </Text>
        <Text mt={4} textAlign={'center'}>
          <Trans
            defaults={t('CLEAR_BY_LEARNED.ERROR_MODAL.DESCRIPTION')}
            components={[<br key="subtitle" />]}
          />
        </Text>
      </Flex>
      <ButtonFilled
        onClick={onResendQuestion}
        mt={'auto'}
        width={1}
        maxWidth={'300px'}
        borderRadius="8px"
        disabled={loading}
      >
        {loading ? (
          <Loading width={20} height={20} />
        ) : (
          t('CLEAR_BY_LEARNED.ERROR_MODAL.RESEND_QUESTION')
        )}
      </ButtonFilled>
      <ButtonText onClick={onBackToClassroom} mt={4} width={1} maxWidth={'300px'} py={0} px={0}>
        {t('CLEAR_BY_LEARNED.ERROR_MODAL.BACK_TO_CLASSROOM')}
      </ButtonText>
    </Flex>
  );
};

ClearErrorContent.propTypes = {
  onResendQuestion: PropTypes.func,
  onBackToClassroom: PropTypes.func,
};

export default ClearErrorContent;
